import { render } from "./ResearchProjectsView.vue?vue&type=template&id=da3f2aa2&ts=true&lang=true"
import script from "./ResearchProjectsView.vue?vue&type=script&lang=ts"
export * from "./ResearchProjectsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__